import {
  VsApiError,
  VsGraphQLError,
  isErrorOfVsApi,
  isErrorOfVsGraphQL,
} from '@vs/rtk/utils';
import { Trans } from 'react-i18next';

import { isGeneralError } from '../helper';
import GeneralErrorInfo from './GeneralErrorInfo';
import { VsApiErrorInfo } from './VsApiErrorInfo';
import VsGraphQLErrorInfo from './VsGraphQLErrorInfo';

type PropsErrorDialogContent = {
  error: unknown;
  sentryId: string;
  showFullErrMsg: boolean;
};

export default function ErrorDialogContent({
  error,
  sentryId,
  showFullErrMsg,
}: PropsErrorDialogContent) {
  return (
    <div>
      <div className="mb-4">
        <Trans
          ns="shared"
          i18nKey={'dialog.unexpected_err.desc'}
          components={{
            a: (
              <a
                href="https://www.viewsonic.com/global/contact/"
                target="_blank"
                rel="noreferrer"
                className="hover:underline text-vs-secondary"
              >
                0
              </a>
            ),
          }}
        />
      </div>
      {(() => {
        if (error !== undefined) {
          switch (true) {
            case error instanceof VsApiError:
              return (
                <VsApiErrorInfo
                  showFullErrMsg={showFullErrMsg}
                  sentryId={sentryId}
                  errorObj={error}
                />
              );
            case error instanceof VsGraphQLError:
              return (
                <VsGraphQLErrorInfo
                  showFullErrMsg={showFullErrMsg}
                  sentryId={sentryId}
                  errorObj={error}
                />
              );
            case isGeneralError(error):
              return (
                <GeneralErrorInfo
                  showFullErrMsg={showFullErrMsg}
                  sentryId={sentryId}
                  errorObj={error}
                />
              );
            default:
              return <div />;
          }
        } else {
          return null;
        }
      })()}
    </div>
  );
}
